import ReusableTable from "@egovernments/digit-ui-module-common/src/sharedComponents/ReusableTable";
import React, { useEffect, useState } from "react";

const columns = [
  { id: "srNo", label: "Sr. No", sortable: false, render: (row, idx) => idx + 1 },
  { id: "name", label: "Name", sortable: true },
  { id: "roleName", label: "Role", sortable: true },
  { id: "approvalRateScore", label: "Approval Rate Score", sortable: true },
  { id: "timelineScore", label: "Timeline Score", sortable: true },
  { id: "resubmissionScore", label: "Resubmission Score", sortable: true },
  {
    id: "totalScore",
    label: "Total Score",
    sortable: false,
    render: (row) => Number(row.approvalRateScore) + Number(row.timelineScore) + Number(row.resubmissionScore),
  },
];

const LTPGrading = () => {
  const [gradingData, setGradingData] = useState([]);

  useEffect(() => {
    const fetchLtpGrading = async () => {
      try {
        const ltpGrading = await Digit.OBPSService.ltpGrading();
        setGradingData(ltpGrading?.DashboardDetails || []);
      } catch (error) {
        console.error("Error fetching ltpGrading:", error);
      }
    };
    fetchLtpGrading();
  }, []);

  return (
    <div style={{ padding: "24px" }}>
      <ReusableTable
        columns={columns}
        data={gradingData}
        tableTitle="LTP Grading Dashboard"
        isLTPGrading={true} // Add this prop
      />
    </div>
  );
};

export default LTPGrading;
